import * as S from '@effect/schema/Schema';
import { Address, Reward } from '@infl-ts/ui-advocate-components';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var SortByEnum = t.keyof({
  RECOMMENDED: null,
  ALPHABETICAL: null,
  PRICE_ASCENDING: null,
  PRICE_DESCENDING: null,
  NEWEST_PUBLISHED: null
});
export var Profile = t.type({
  id: t.string,
  currentPoints: t.number,
  isAdmin: t["boolean"],
  shippingAddress: nullable(Address)
});
export var RewardsAndPointsOutput = t.type({
  rewards: t.type({
    edges: t.array(t.type({
      node: Reward,
      cursor: t.string
    })),
    totalCount: t.number
  }),
  profile: Profile
});
export var RewardCategoriesItem = t.type({
  id: t.string,
  name: t.string
});
export var RewardCategories = t.type({
  rewardCategories: t.array(RewardCategoriesItem)
});
export var RewardsAndPointsInput = t.intersection([t.type({
  sufficientPoints: t["boolean"],
  onWishlist: t["boolean"]
}), t.partial({
  first: t.number,
  after: t.string,
  sortType: SortByEnum,
  categoryIds: t.array(t.string)
})]);
export var sortQueryMapper = {
  Recommended: 'RECOMMENDED',
  'A to Z': 'ALPHABETICAL',
  'Price: Low to High': 'PRICE_ASCENDING',
  'Price: High to Low': 'PRICE_DESCENDING',
  Newest: 'NEWEST_PUBLISHED'
};
export var RewardsBlockConfig = S.struct({
  typename: S.literal('RewardsBlock'),
  id: S.string,
  hash: S.string,
  basepath: S.string
});